<script setup lang="ts">
/*
 * FILE: unified_ui/src/components/AuthGate.vue
 * PURPOSE: Client-side access gate shown when the SPA boots without any valid
 *          auth method (Telegram, Max, iframe token, session cookie, or dev auth).
 *          Mirrors the previous server-side 403 page so users see a consistent
 *          message, but the decision is made in the app after trying all flows.
 */
</script>

<template>
  <div class="flex h-screen w-full items-center justify-center bg-slate-50 p-6 text-slate-900">
    <div
      class="max-w-md w-full rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-xl"
    >
      <h1 class="mb-3 text-2xl font-semibold">Доступ запрещён</h1>
      <p class="mb-6 text-base text-slate-600">
        Используйте авторизованный вход:
      </p>
      <ul class="list-disc pl-6 text-left text-sm leading-7 text-slate-600">
        <li>Telegram Mini App</li>
        <li>Страница авторизованного сайта</li>
      </ul>
    </div>
  </div>
</template>
